import { Transform } from 'class-transformer';
import { isDefined } from 'class-validator';

export function Default<TValue>(defaultValue: TValue): PropertyDecorator {
  return Transform(
    ({ value }) => {
      return isDefined(value) ? value : defaultValue;
    },
    { toClassOnly: true },
  );
}
